<template>
  <div class="fixed inset-0 bg-black/50 z-1000" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Overlay'
});
</script>
